"use strict";

let productObj = window.productObj;
(function () {
  $(document).ready(function () {
    collectionFilter();
    productVariantSelect();
    initVariant();
    setVariantIDPLP();
    initVariantColorPLP();
  });
})($);
function collectionFilter() {
  $(".filter-product").on("click", function () {
    if ($(this).hasClass("selected")) {
      return;
    }
    $(".filter-tags-content").show();
    var filterType = $(this).data("filter-type").toLowerCase();
    var filterValue = $(this).data("filter-option");
    $(this).addClass("selected");
    var filterOption = '<li class="selected-filter" data-selected-filter="' + filterValue + '"><a>' + filterValue + "</a></li>";
    $(".filter-row").append(filterOption);
    visibilityProducts(filterValue, filterType);
  });
  $(document).on("click", ".selected-filter", function () {
    var selectedFilter = $(this).data("selected-filter");
    $(this).remove();
    $("[data-filter-option=" + selectedFilter + "]").removeClass("selected");
  });
  $(".filter-clear").on("click", function () {
    $(".selected-filter").remove();
    $(".filter-product").removeClass("selected");
    $(".filter-tags-content").hide();
    visibilityProducts();
  });
}
function visibilityProducts(filterValue = "clear", filterType = "clear") {
  if (filterValue == "clear" && filterType == "clear") {
    $(".shop-page-main-products-col").show();
    $(".shop-page-main-products-col").removeClass("active");
    return;
  }
  if (filterType == "color") {
    $("[data-product-" + filterType + "]").each(function (key, val) {
      var product_color_string = $(this).data("product-" + filterType);
      var product_color_arr = product_color_string.split(", ");
      if (product_color_arr.indexOf(filterValue) == -1) {
        $(this).removeClass("active");
        $(this).hide();
      } else {
        $(this).addClass("active");
        $(this).show();
      }
    });
  } else {
    $("[data-product-" + filterType + "]").each(function (key, val) {
      if ($(this).hasClass("active")) {
        return;
      }
      if ($(this).data("product-" + filterType) != filterValue) {
        $(this).removeClass("active");
        $(this).hide();
      } else {
        $(this).addClass("active");
        $(this).show();
      }
    });
  }
}
function updateCurrentProductUrl(selected_variant_id) {
  window.history.replaceState({}, "", `${document.location.pathname}?variant=${selected_variant_id}`);
}
function productVariantSelect() {
  var variants = [];
  $(".gift-cart-variant-options").on("click", function () {
    var variant_price = $(this).data("variant-price");
    var variant_price_no_format = $(this).data("variant-price-no-format");
    var variant_id = $(this).data("variant-id");
    $("#pdp_option_name").text(variant_price);
    $(".pdp-add-to-cart-btn").attr("data-variant-id", variant_id);
    $("#product-variant-price").text(variant_price).data("product-price", variant_price_no_format);
    $(".product_selected_quantity").val(1);
  });
  $(".variant-options").on("click", function () {
    $(".variant-details-tab").hide();
    $(".product_selected_quantity").val(1);
    var variantOptionName = $(this).data("option-name");
    var variantOptionValue = $(this).data("option-value");
    $("#pdp_" + variantOptionName + "_name").text(variantOptionValue);
    $(".pdp-add-to-cart-btn").attr("data-variant-" + variantOptionName.toLowerCase(), variantOptionValue);
    var variant_id = getVariantID();
    var variant_sku = getVariantSku();
    $("#product-variant-sku").text("SKU: " + variant_sku);
    $(".pdp-add-to-cart-btn").attr("data-variant-id", variant_id);
    updateCurrentProductUrl(variant_id);
    if (variantOptionName == "Color") {
      activateVariantImagesGallery(variantOptionValue);
    }
    for (let key in productObj.variants) {
      if (productObj.variants[key].id == variant_id) {
        var product_price = productObj.variants[key].price / 100 * 1;
        if (typeof Shopify.currency.active != "undefined") {
          $("#product-variant-price").text(product_price.toFixed(2) + " " + Shopify.currency.active).data("product-price", product_price * 100);
        } else {
          $("#product-variant-price").text("$" + product_price.toFixed(2)).data("product-price", product_price * 100);
        }
        $("#variant_details_" + productObj.variants[key].id).show();
        initSoldOutButton(productObj.variants[key].available);
      }
    }
    updateProductBottlesInfo(variant_id);
  });
}
function initVariant() {
  var currentSizeID = $("[name=size]:checked").attr("id");
  var currentColorID = $("[name=color]:checked").attr("id");
  var currentSize = $("[data-option-id=" + currentSizeID + "]").data("option-value");
  var currentColor = $("[data-option-id=" + currentColorID + "]").data("option-value");
  $(".pdp-add-to-cart-btn").attr("data-variant-size", currentSize);
  $(".pdp-add-to-cart-btn").attr("data-variant-color", currentColor);
  $(".product-variants-list").each(function (el, index) {
    var size = $(this).data("variant-size");
    var color = $(this).data("variant-color");
    if (size == currentSize && color == currentColor) {
      var variantID = $(this).data("variant-id");
      var variant_available = $(this).data("variant-available");
      initSoldOutButton(variant_available);
      $(".pdp-add-to-cart-btn").attr("data-variant-id", variantID);
      $("#variant_details_" + variantID).show();
    }
  });
}

// function updateURL() {
//     if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
//     window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
// }

function initSoldOutButton(variant_available) {
  if (variant_available == true) {
    $(".soldout-pdp-label").hide();
    $(".pdp-add-to-cart-action").show();
    $("#inform-me-when-in-stock").hide();
  } else {
    $(".soldout-pdp-label").show();
    $(".pdp-add-to-cart-action").hide();
    $("#inform-me-when-in-stock").show();
  }
}
function getVariantID() {
  var variantID = "";
  var currentColor = $(".pdp-add-to-cart-btn").attr("data-variant-color");
  var currentSize = $(".pdp-add-to-cart-btn").attr("data-variant-size");
  for (let key in productObj.variants) {
    if (productObj.variants[key].option1 == currentColor && productObj.variants[key].option2 == currentSize) {
      variantID = productObj.variants[key].id;
    }
  }
  return variantID;
}
function getVariantSku() {
  var variantSku = "";
  var currentColor = $(".pdp-add-to-cart-btn").attr("data-variant-color");
  var currentSize = $(".pdp-add-to-cart-btn").attr("data-variant-size");
  for (let key in productObj.variants) {
    if (productObj.variants[key].option1 == currentColor && productObj.variants[key].option2 == currentSize) {
      variantSku = productObj.variants[key].sku;
    }
  }
  return variantSku;
}
function setVariantIDPLP() {
  $(".general-style-product").each(function (productIndex, product) {
    var product = $(product);
    var currentSize = $(".quick-add-to-cart-btn", product).data("variant-size");
    var currentColor = $(".quick-add-to-cart-btn", product).attr("data-variant-color");
    $(".product-variant", product).each(function (variantIndex, variant) {
      var size = $(variant).data("variant-size");
      var color = $(variant).data("variant-color");
      if (size == currentSize && color == currentColor) {
        var variantID = $(variant).data("variant-id");
        $(".quick-add-to-cart-btn", product).attr("data-variant-id", variantID);
      }
    });
  });
}
function initVariantColorPLP() {
  $(".preview-product-variant-gift-cart").on("click", function () {
    var selected_price = $(this).parent().text().trim();
    var rand_number = $(this).data("rand-number");
    var productID = $(this).data("product-id");
    var variantAvailable = $(this).data("variant-available");
    var variantID = $(this).data("variant-id");
    $("#product_id_" + productID + "_" + rand_number).attr("data-variant-id", variantID);
    if (variantAvailable == true) {
      $("#selected_price_" + productID).text(selected_price);
      $("#product_id_" + productID + "_" + rand_number).text("Add to Cart");
      $("#product_sold_out_" + productID + "_" + rand_number).hide();
    } else {
      $("#product_id_" + productID + "_" + rand_number).text("Sold Out");
      $("#product_sold_out_" + productID + "_" + rand_number).show();
    }
  });
  $(".preview-product-variant-color").on("click", function () {
    var rand_number = $(this).data("rand-number");
    var productID = $(this).data("product-id");
    var currentColor = $(this).data("option-color");
    var variantAvailable = $(this).data("variant-available");
    var currentSize = $("#product_id_" + productID + "_" + rand_number).data("variant-size");
    var variantsList = $(".all-variants-" + productID);
    var counter = $(this).data("counter");
    if (variantAvailable == true) {
      $("#product_id_" + productID + "_" + rand_number).text("Add to Cart");
      $("#product_sold_out_" + productID + "_" + rand_number).hide();
    } else {
      $("#product_id_" + productID + "_" + rand_number).text("Sold Out");
      $("#product_sold_out_" + productID + "_" + rand_number).show();
    }
    $(".product-variant", variantsList).each(function (variantIndex, variant) {
      var size = $(variant).data("variant-size");
      var color = $(variant).data("variant-color");
      if (size == currentSize && color == currentColor) {
        var variantID = $(variant).data("variant-id");
        $("#product_id_" + productID + "_" + rand_number).attr("data-variant-id", variantID);
        var currentVariantImage = $("#variant_image_" + productID + "_" + variantID + "_" + rand_number).length;
        if (currentVariantImage > 0) {
          $("#product_" + productID + "_general_image_" + rand_number + ", .product_" + productID + "_variant_image_" + rand_number).hide();
          $("#variant_image_" + productID + "_" + variantID + "_" + rand_number).show();
        }
      }
    });
  });
}
function updateProductBottlesInfo(variant_id) {
  const match = productBottlesMetaobject.variants.find(v => v.id === variant_id);
  if (match && match.bottles) {
    document.querySelector("#bottles-you-save .bottles-you-save__title--content").textContent = match.bottles.title;
    document.querySelector("#bottles-you-save .bottles-you-save__content--content").textContent = match.bottles.content;
    document.querySelector("#bottles-you-save .bottles-you-save__numbers--circle").textContent = match.bottles.number;
  }
}